// Import Rails functionalities
import Rails from "@rails/ujs";
import * as Turbo from '@hotwired/turbo'
import * as ActiveStorage from "@rails/activestorage";

import ReactDOM from "react-dom/client"
import App from "../App"
import { BrowserRouter } from "react-router-dom"


// Start Rails functionalities
Rails.start();
Turbo.start()
ActiveStorage.start();

// Import Sentry
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

// Initialize Sentry
const sentryDsn = import.meta.env.VITE_SENTRY_DSN || '';

Sentry.init({
    dsn: sentryDsn,
    tracesSampleRate: 0.5,
    beforeSend(event, hint) {
        const error = hint.originalException

        // Handle Error object instances
        if (error instanceof Error) {
            return event
        }

        // Handle string exceptions
        if (typeof error === "string") {
            event.message = `Caught a string exception: ${error}`
            return event
        }

        // Handle object exceptions
        if (typeof error === "object" && error !== null) {
            // Convert the error object to a JSON string and include it in the message
            const errorString = JSON.stringify(error)
            event.title = `Non-Error exception captured with key/values: ${errorString}`
            event.message = `Caught an object exception: ${errorString}`

            // Optionally, you can add the error object to event.extra for better visibility in Sentry
            event.extra = event.extra || {}
            event.extra.errorObject = error

            return event
        }

        return event
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const rootElement = document.getElementById("root")
    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement)
        root.render(
            <BrowserRouter>
                <App />
            </BrowserRouter>,
        )
    } else {
    }
})

// Import ReactRailsUJS
import ReactRailsUJS from 'react_ujs';

// Import all your components using Vite's `import.meta.globEager`
const componentRequireContext = import.meta.glob('../components/**/*.tsx', { eager: true });

// Create a mapping from component names to components
const components = {};

for (const key in componentRequireContext) {
    const module = componentRequireContext[key];
    const paths = key.split('/');
    const filename = paths[paths.length - 1];
    const componentName = filename.split('.')[0];

    const component =
        module.default || // Default export
        module[componentName] || // Named export matching the component name
        Object.values(module)[0]; // First export in case of unnamed exports

    if (!component) {
        console.error(`Could not find component export for ${componentName}`);
    }

    components[componentName] = component;
}

window.ReactRailsUJS = ReactRailsUJS;
window.ReactComponents = components;

// Override getConstructor to use global components
ReactRailsUJS.getConstructor = function (className) {
    const componentClass = window.ReactComponents[className];
    if (componentClass == null) {
        throw new Error(`Cannot find component: '${className}'. Make sure your component is available to render.`);
    }
    return componentClass;
};

document.addEventListener('turbo:load', () => {
    ReactRailsUJS.mountComponents();
});


document.addEventListener('turbo:before-render', () => {
    ReactRailsUJS.unmountComponents();
});
